import { hydrateServicesData } from '../components/services/serviceData';
import { hydrateServiceDetails } from '../components/services/serviceDetailContent';
import { hydrateCaseStudiesListing } from '../components/case-studies/caseStudiesListingData';
import { hydrateCaseStudyDetails } from '../components/case-studies/caseStudyDetailContent';
import { hydrateBlogContent } from '../components/blog/blogPostsData';
import { hydrateTeamMembers } from '../components/about/teamMembersData';
import { hydrateBlogVideos } from '../blog/blogVideos';
import { hydrateBlogHeroVideo, resolveBlogHeroVideoUrl } from '../media/blogHeroMedia';
import { hydrateSolutionVideos } from '../components/home/solutionVideosData';
import { hydrateHomeTestimonials } from '../components/home/testimonialsHomeData';

export function hydrateAllContent(content) {
  if (!content || typeof content !== 'object') return;

  if (content.services) {
    hydrateServicesData(content.services);
    if (content.services.details) hydrateServiceDetails(content.services.details);
  }

  if (content.caseStudies) {
    hydrateCaseStudiesListing({
      stats: content.caseStudies.stats,
      cards: content.caseStudies.cards,
      categories: content.caseStudies.categories,
    });
    if (content.caseStudies.details) hydrateCaseStudyDetails(content.caseStudies.details);
  }

  if (content.blogs) {
    hydrateBlogContent({
      posts: content.blogs.posts,
      categories: content.blogs.categories,
      featuredIdsByTopic: content.blogs.featuredIdsByTopic,
      browseTopicKeys: content.blogs.browseTopicKeys,
    });
    if (content.blogs.videoPool?.length) hydrateBlogVideos(content.blogs.videoPool);
    const heroFromBlogs = resolveBlogHeroVideoUrl(content.blogs.heroVideo);
    hydrateBlogHeroVideo(heroFromBlogs);
  }

  if (content.team?.length) {
    hydrateTeamMembers(content.team);
  }

  if (content.testimonials?.items?.length) {
    hydrateHomeTestimonials(content.testimonials.items);
  }

  if (content.media) {
    if (content.media.blogVideoPool?.length) hydrateBlogVideos(content.media.blogVideoPool);
    hydrateBlogHeroVideo(
      resolveBlogHeroVideoUrl(content.media.blogHeroVideo, content.blogs?.heroVideo)
    );
    if (content.media.solutionVideos) hydrateSolutionVideos(content.media.solutionVideos);
  }
}
